import React from 'react';

export type ProgramExportLearningContentModalProps = {
  open: boolean;
  onClose: () => void;
  applying: boolean;
  gradeNumber: 1 | 2 | 3 | 4 | 5 | 6;
  termNumber: 1 | 2;
  templateName: string;
  onConfirm: () => Promise<void>;
};

const ProgramExportLearningContentModal: React.FC<ProgramExportLearningContentModalProps> = ({
  open,
  onClose,
  applying,
  gradeNumber,
  termNumber,
  templateName,
  onConfirm,
}) => {
  if (!open) return null;

  const scopeLabel = `${gradeNumber}학년 ${termNumber}학기`;
  const trimmedTemplateName = templateName.trim() || '편제';

  return (
    <div
      className="cp-modal-backdrop"
      role="presentation"
      onMouseDown={(e) => {
        if (e.target === e.currentTarget && !applying) onClose();
      }}
    >
      <div
        className="cp-modal cp-program-page-split-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="cp-program-export-learning-title"
        onMouseDown={(e) => e.stopPropagation()}
      >
        <h3 id="cp-program-export-learning-title">학습내용 내보내기</h3>
        <div className="cp-modal-body">
          <p>
            현재 프로그램의 단원~평가 데이터를 기본 학습내용 등록의 사용자 편제로 저장합니다.
          </p>
          <p>
            <strong>
              {scopeLabel} · 「{trimmedTemplateName}」
            </strong>{' '}
            편제로 생성되며 같은 학년, 학기, 편제명으로 내보내기된 데이터가 있으면 해당 편제의 데이터는
            삭제되고 이번 내보내기 데이터로 대체됩니다.
          </p>
        </div>
        <div className="cp-modal-footer">
          <button type="button" className="cp-btn-secondary" disabled={applying} onClick={onClose}>
            취소
          </button>
          <button
            type="button"
            className="cp-btn-primary"
            disabled={applying}
            onClick={() => {
              void onConfirm();
            }}
          >
            {applying ? '내보내는 중…' : '내보내기'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProgramExportLearningContentModal;
